import React, { ReactElement } from "react";
import { Box, SxProp } from "theme-ui";
import {
  BlockType,
  FCTertiaryBlock,
  TertiaryBlockType,
  TertiaryBlockSize,
} from "../typings";
import { BlockAsProp } from "../typings/block-prop-types";

type TertiaryBlockConfig = {
  blockSize: TertiaryBlockSize | TertiaryBlockSize[];
};

/** TertiaryBlock section */
function tertiaryBlock<T extends TertiaryBlockType>(
  blockConfig: TertiaryBlockConfig,
  RenderComponent: (props: T) => ReactElement
): FCTertiaryBlock<T> {
  const { blockSize } = blockConfig;
  const block: FCTertiaryBlock<T> = (props: T): ReactElement => {
    const Component = RenderComponent(props);
    return <Box className="section-tertiary-block">{Component}</Box>;
  };
  block.blockConfig = blockConfig;
  block.blockSize = blockSize;
  block.blockType = BlockType.Tertiary;
  return block;
}

const renderTertiaryBlock = (
  blockProp?: BlockAsProp,
  sxProps: SxProp = {}
): null | ReactElement => {
  if (!blockProp || !blockProp.block) return null;
  return (
    <Box
      className="tertiary-block"
      sx={{
        marginTop: "1.5rem",
        marginBottom: "1.5rem",
        ...(sxProps.sx ?? {}),
      }}
    >
      {React.createElement(
        blockProp.block,
        blockProp.props,
        blockProp.children
      )}
    </Box>
  );
};

export { tertiaryBlock, renderTertiaryBlock };
export type { TertiaryBlockConfig };
